import { gql } from '@apollo/client';

export const ROUTE_TREE_LIST = gql`
  query routeTreeList {
    route(where: { parentId: { _is_null: true }, global: { _eq: false } }) {
      id
      name
      iconName
      global
      routes {
        id
        name
        iconName
        global
      }
    }
  }
`;
